import React from "react";
import { Typography, IconButton, Card, CardContent, CardHeader, Avatar, TextField, DialogTitle, DialogContent, DialogActions, Button, InputAdornment, FormControl, InputLabel, Select, MenuItem, Menu, Divider } from "@mui/material";
import { PersonOff } from '@mui/icons-material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { D } from "../include";
import {PlanningDialog} from "./Planning";


export class Session extends React.Component {
  constructor(props) {
    super(props); 
         
    this.state = {
      patient_id: this.props.patient_id ? this.props.patient_id : -1,
      procedure_id: this.props.data ? this.props.data.procedure_id : -1,
      session_id: this.props.data ? this.props.data.id : -1,
      doctor_id: this.props.data ? this.props.data.doctor_id : -1, 
      doctor_name: this.props.data ? this.props.data.doctorname : '',    
      created_at: this.props.data ? (new Date(this.props.data.created_at)).toLocaleString('pt-BR', { timeZone: 'America/Sao_Paulo', timeZoneName: 'short' }) : '',
      noshow: this.props.data ? this.props.data.noshow : false,
      notes: this.props.data ? this.props.data.notes : '',
      nudge: this.props.data ? this.props.data.nudge : '', 
      prescription_id: this.props.data ? this.props.data.prescription_id : '',
      contact_within_hours: this.props.data ? this.props.data.contact_within_hours : 24,
      planning_background_file_id: this.props.data ? this.props.data.planning_background_file_id : -1,
      template_image_id: this.props.template_image_id ? this.props.template_image_id : -1,
      previous_planning_background_file_id: this.props.data ? this.props.data.planning_background_file_id : -1,
      signed: this.props.data ? this.props.data.signed : false,
      anchorEl: null,
      openMenu: false,
    }; 
  } 

  handleClick = (event) => {
    this.setState({ anchorEl: event.currentTarget, openMenu: Boolean(event.currentTarget) });
  };
  
  handleClose = () => {
    this.setState({ anchorEl: null, openMenu: false });
  }; 
  
  handleDoctor = () => {
    this.setState({ anchorEl: null, openMenu: false });
    
    this.props.dialog(
      <InputDialog
        session_id={this.state.session_id}
        doctor_id={this.state.doctor_id}
        contact_within_hours={null}
        notes={null}
        prescription_id={null}
        doctorContext={true}
        notesContext={false}
        contact_within_hoursContext={false}
        prescriptionContext={false}
        read_only={this.state.signed}
        api={this.props.api}
        alert={this.props.alert}
        dialogClose={() => {
          this.props.dialogClose();
        }}
        dialogSave={(d,n,f,p,pr,v,c) => {
          this.saveValue(d,n,f,p,pr,v,c);
        }}
      />
    )
  };
  
  handleDoctorDialogReturn = (value, complement_value) => {
    this.props.api
      .post('/MedicalSessionsDoctor/'+this.state.session_id, { doctor: value })
      .then((r) => {
        this.setState({ doctor_id: value, doctor_name: complement_value });
        if("error" in r)
            this.props.alert(r.error);
          else
            this.props.alert('Sessão atualizada com sucesso');
      })
      .catch((err) => {
        this.props.alert('Ocorreu um erro ao atualizar os registros')
      });
  } 
  
  handleNoShow = () => {
    this.setState({ anchorEl: null, openMenu: false });
    
    this.props.api
      .post('/MedicalSessionsNoShow/'+this.state.session_id, { noshow: (!this.state.noshow) })
      .then((r) => {
        this.setState({ noshow: (!this.state.noshow) });
        if("error" in r)
            this.props.alert(r.error);
          else
            this.props.alert('Sessão atualizada com sucesso');
      })
      .catch((err) => {
        this.props.alert('Ocorreu um erro ao atualizar os registros')
      });
  };
  
  handleNote = () => {
    this.setState({ anchorEl: null, openMenu: false });
    
    this.props.dialog(
      <InputDialog
        session_id={this.state.session_id}
        doctor_id={null}
        contact_within_hours={null}
        notes={this.state.notes}
        prescription_id={null}
        doctorContext={false}
        notesContext={true}
        contact_within_hoursContext={false}
        prescriptionContext={false}
        read_only={this.state.signed}
        api={this.props.api}
        alert={this.props.alert}
        dialogClose={() => {
          this.props.dialogClose();
        }}
        dialogSave={(d,n,f,p,pr,v,c) => {
          this.saveValue(d,n,f,p,pr,v,null);
        }}
      />
    )
  }; 
  
  handleNoteDialogReturn = (value) => {
    this.props.api
      .post('/MedicalSessionsNote/'+this.state.session_id, { notes: value, procedure_id: this.state.procedure_id })
      .then((r) => {
        this.setState({ notes: value });
        if("error" in r)
            this.props.alert(r.error);
          else
            this.props.alert('Sessão atualizada com sucesso');
      })
      .catch((err) => {
        this.props.alert('Ocorreu um erro ao atualizar os registros')
      });
  } 
  
  handlePlanning = () => {
    this.setState({ anchorEl: null, openMenu: false });
    
    this.props.dialog(
      <PlanningDialog
        session_id={this.state.session_id}
        background_image_id={this.state.planning_background_file_id}
        template_image_id={this.state.template_image_id}
        read_only={this.state.signed}
        api={this.props.api}
        alert={this.props.alert}
        dialog={this.props.dialog}
        dialogClose={() => {
          this.props.dialogClose();
        }}
        dialogSave={(d,n,f,p,pr,v,c) => {
          this.saveValue(d,n,f,p,pr,v,null);
        }}
      />
    )
  }; 
  
  handlePlanningDialogReturn = (value) => {
    this.props.api
      .post('/MedicalSessionsPlan/'+this.state.session_id, { patient_id: this.state.patient_id, previous_planning_background_file_id: this.state.previous_planning_background_file_id, planning_background_file_id: value })
      .then((r) => {
        this.setState({ planning_background_file_id: value });
        if("error" in r)
            this.props.alert(r.error);
          else
            this.props.alert('Sessão atualizada com sucesso');
      })
      .catch((err) => {
        this.props.alert('Ocorreu um erro ao atualizar os registros')
      });
  }
  
  
  handlePrescription = () => {
    this.setState({ anchorEl: null, openMenu: false });
    this.props.dialog(
      <InputDialog
        session_id={this.state.session_id}
        doctor_id={null}
        contact_within_hours={null}
        notes={null}
        prescription_id={this.state.prescription_id}
        doctorContext={false}
        notesContext={false}
        contact_within_hoursContext={false}
        prescriptionContext={true}
        read_only={this.state.signed}
        api={this.props.api}
        alert={this.props.alert}
        dialogClose={() => {
          this.props.dialogClose();
        }}
        dialogSave={(d,n,f,p,pr,v,c) => {
          this.saveValue(d,n,f,p,pr,v,null);
        }}
      />
    )
  }; 
  
  handlePrescriptionDialogReturn = (value) => {
    this.props.api
      .put('/Prescription/'+this.state.prescription_id, { medication: value })
      .then((r) => {
        this.setState({ medication: value });
        if("error" in r)
            this.props.alert(r.error);
          else
            this.props.alert('Medicação e Orientação atualizadas com sucesso');
      })
      .catch((err) => {
        this.props.alert('Ocorreu um erro ao atualizar os registros')
      });
  } 
   
  
  handleFollowUp = () => {
    this.setState({ anchorEl: null, openMenu: false });
    this.props.dialog(
      <InputDialog
        session_id={this.state.session_id}
        doctor_id={null}
        contact_within_hours={this.state.contact_within_hours}
        notes={null}
        prescription_id={null}
        doctorContext={false}
        notesContext={false}
        contact_within_hoursContext={true}
        prescriptionContext={false}
        read_only={false}
        api={this.props.api}
        alert={this.props.alert}
        dialogClose={() => {
          this.props.dialogClose();
        }}
        dialogSave={(d,n,f,p,pr,v,c) => {
          this.saveValue(d,n,f,p,pr,v,null);
        }}
      />
    )
  };  
  
  handleFollowUpDialogReturn = (value) => {
    this.props.api
      .post('/MedicalSessionsFollowup/'+this.state.session_id, { contact_within_hours: value })
      .then((r) => {
        this.setState({ contact_within_hours: value });
        if("error" in r)
            this.props.alert(r.error);
          else
            this.props.alert('Sessão atualizada com sucesso');
      })
      .catch((err) => {
        this.props.alert('Ocorreu um erro ao atualizar os registros')
      });
  }
  
  saveValue = (bDoc,bNot,bFup,bPlan,bPresc,value,complement_value) => {   
    if(bDoc) this.handleDoctorDialogReturn(value,complement_value);
    if(bNot) this.handleNoteDialogReturn(value);
    if(bFup) this.handleFollowUpDialogReturn(value);
    if(bPlan) this.handlePlanningDialogReturn(value);
    if(bPresc) this.handlePrescriptionDialogReturn(value);
  }
  
  handleDelete = () => {
    this.setState({ anchorEl: null, openMenu: false });
    
    this.props.api
      .delete('/MedicalSessions/'+this.state.session_id)
      .then((r) => {
        if("error" in r)
            this.props.alert(r.error);
          else{
            this.props.alert('Sessão apagada com sucesso');
            this.props.handleProcedureUpdate();
          }
      })
      .catch((err) => {
        this.props.alert('Ocorreu um erro ao buscar os registros')
      });
  };
  
  render() {  
    return (   
    <Card  sx={{ maxWidth: '345px', minHeight: '200px', margin: '0.5rem', }} component={D} className="col aF" >
      <CardHeader
        title={this.state.created_at}
        subheader={this.state.doctor_name}
        avatar={this.state.noshow ? <Avatar><PersonOff/></Avatar> : <Avatar sx={{bgcolor: 'white'}}></Avatar>}
        action={
          <div>
          <IconButton
            id="basic-button"
            aria-controls={this.state.openMenu ? 'basic-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={this.state.openMenu ? 'true' : undefined}
            onClick={this.handleClick}
          >
            <MoreVertIcon />
          </IconButton>
          <Menu
            id="basic-menu"
            anchorEl={this.state.anchorEl}
            open={this.state.openMenu}
            onClose={this.handleClose}
            MenuListProps={{
              'aria-labelledby': 'basic-button',
            }}
          >
            <MenuItem onClick={this.handleDoctor}>Profissional Saúde</MenuItem>
            <MenuItem onClick={this.handleNoShow}>No Show</MenuItem>
            <MenuItem onClick={this.handleNote}>Anotação de Tratamento</MenuItem>
            <MenuItem onClick={this.handlePlanning}>Plano de Tratamento</MenuItem>
            <MenuItem onClick={this.handlePrescription}>Orientação e Medicação</MenuItem>
            <MenuItem onClick={this.handleFollowUp}>Follow Up</MenuItem>
            <Divider />
            <MenuItem onClick={this.handleDelete}>Apagar</MenuItem>
          </Menu>
          </div>
        }
      />
      <CardContent>
        <Typography variant="body2">{this.state.notes}</Typography>
        <Typography sx={{ color: 'text.secondary', fontSize: 10 }}>Follow up em {this.state.contact_within_hours} horas</Typography>
        <Typography sx={{ color: 'text.secondary', fontSize: 10 }}>{this.state.nudge}</Typography>
      </CardContent>
    </Card>
    );
  }
}






export class NewSessionDialog extends React.Component {
  constructor(props) {
    super(props);    
    this.state = {
      procedure_id: this.props.procedure_id ? this.props.procedure_id : -1,
      patient_id: this.props.patient_id ? this.props.patient_id : -1,
      company_id: this.props.company_id ? this.props.company_id : -1,
      doctor_id: '',
      notes: "",
      medication: "",
      contact_within_hours: 24,
      planning_background_file_id: this.props.planning_background_file_id ? this.props.planning_background_file_id : -1,
      template_image_id: this.props.data ? this.props.data.template_image_id : -1,
      doctor_list: {},
    }; 
  }
  
  
  componentDidMount() {
    this.setState({ loading: true });
    this.props.api
      .get('/Doctors')
      .then((r) => {
        var list = {}
        for(var row in r.doctors){
          list[ r.doctors[row]["id"] ]= r.doctors[row]["name"];          
        }
        this.setState({
          doctor_list: list,
        });
      })
      .catch(() => {
        this.props.alert('Ocorreu um erro ao buscar os registros')
      });
  }
 
  
  handleSave = () => {
    this.props.api
      .post('/MedicalSessions', { patient_id: this.state.patient_id, doctor_id: this.state.doctor_id, procedure_id: this.state.procedure_id, company_id: this.state.company_id, noshow: this.state.noshow, contact_within_hours: this.state.contact_within_hours, notes: this.state.notes, planning_background_file_id: this.state.planning_background_file_id })
      .then((r) => {
        if("error" in r)
            this.props.alert(r.error);
        else{
          this.props.alert('Sessão criada com sucesso');
        }
        this.props.updateProcedureData();
      })
      .catch(() => {
        this.props.alert('Ocorreu um erro ao buscar os registros')
      });
    this.props.dialogClose();
  }  
  

  render() {
    return (
      <D className="col e aF pa">
        <DialogTitle>Nova Sessão</DialogTitle>
        <DialogContent style={{ minWidth: "25vw" }}>
          <D h="1rem" />
          <FormControl style={{paddingTop: '0.5rem'}} fullWidth>
            <InputLabel id="select-type">Profissional de Saúde</InputLabel>
            <Select
              labelId="select-doctor"
              id="select-t"
              value={Object.keys(this.state.doctor_list).length>0 ? this.state.doctor_id : ''}
              label="Profissional de Saúde"
              onChange={(e) => this.setState({doctor_id: e.target.value})}
            >
              {Object.keys(this.state.doctor_list).map(key => {
                  return <MenuItem key={key} value={key}>{this.state.doctor_list[key]}</MenuItem>
                })
              }
            </Select>
          </FormControl>
          <D h="1rem" />
          <TextField
            fullWidth
            variant="outlined"
            label="Disparar follow up depois de"
            type="number"
            InputProps={{
              endAdornment: <InputAdornment position="end">horas</InputAdornment>
            }}
            value={this.state.contact_within_hours}
            onChange={(e) => this.setState({ contact_within_hours: e.target.value })}
          />
          <D h="1rem" />
          <TextField
            fullWidth
            variant="outlined"
            label="Anotação de Tratamento"
            multiline
            value={this.state.notes}
            inputProps={{ maxLength: 512 }}
            onChange={(e) => this.setState({ notes: e.target.value })}
          />
          <D h="2rem" />
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" color="primary" onClick={this.props.dialogClose}>Cancelar</Button>
          <Button variant="outlined" color="primary" onClick={this.handleSave} disabled={this.state.doctor_id<=0}>Salvar</Button>
        </DialogActions>
      </D>
    );
  }
}







class InputDialog extends React.Component {
  constructor(props) {
    super(props);    
    this.state = {
      session_id: this.props.session_id ? this.props.session_id : -1,
      doctor_id: this.props.doctor_id ? this.props.doctor_id : '',
      notes: this.props.notes ? this.props.notes : "",
      medication: "",
      prescription_id: this.props.prescription_id ? this.props.prescription_id : "",
      contact_within_hours: this.props.contact_within_hours ? this.props.contact_within_hours : "",
      doctorContext: this.props.doctorContext ? this.props.doctorContext : false,
      notesContext: this.props.notesContext ? this.props.notesContext : false,
      prescriptionContext: this.props.prescriptionContext ? this.props.prescriptionContext : false,
      contact_within_hoursContext: this.props.contact_within_hoursContext ? this.props.contact_within_hoursContext : false,
      read_only: this.props.read_only ? this.props.read_only : false,
      doctor_list: {},
    }; 
  }
   
  componentDidMount() {
    if(this.state.doctorContext){
      this.setState({ loading: true });
      this.props.api
        .get('/Doctors')
        .then((r) => {
          var list = {}
          for(var row in r.doctors){
            list[ r.doctors[row]["id"] ]= r.doctors[row]["name"];          
          }
          this.setState({
            doctor_list: list,
          });
        })
        .catch(() => {
          this.props.alert('Ocorreu um erro ao buscar os registros')
        });
    }
    
    if(this.state.prescriptionContext){
      this.setState({ loading: true });
      this.props.api
        .get('/Prescription/' + this.state.prescription_id)
        .then((r) => {
          var medication = "Não há."
          if(r)
            medication = r.text;

          this.setState({
            medication: medication,
          });
        })
        .catch(() => {
          this.props.alert('Ocorreu um erro ao buscar os registros')
        });
    }
  } 
  
  handleSave = () => {
    this.props.dialogClose();
    
    if(this.state.doctorContext) this.props.dialogSave(true,false,false,false,false,this.state.doctor_id,this.state.doctor_list[this.state.doctor_id]);
    if(this.state.contact_within_hoursContext) this.props.dialogSave(false,false,true,false,false,this.state.contact_within_hours,null);
    if(this.state.notesContext) this.props.dialogSave(false,true,false,false,false,this.state.notes,null);
    if(this.state.prescriptionContext) this.props.dialogSave(false,false,false,false,true,this.state.medication,null);
  }
  
  
  render() {
    return (
      <D className="col e aF pa">
        <DialogTitle>Editar {this.state.doctorContext ? "Profissional de Saúde": ""}{this.state.notesContext ? "Anotação" :""}{this.state.contact_within_hoursContext ? "Follow Up" :""}{this.state.prescriptionContext ? "Orientação e Medicação" :""}</DialogTitle>
        <DialogContent style={{ minWidth: "25vw" }}>
          <D h="1rem" />
          {this.state.doctorContext && <>
          <FormControl style={{paddingTop: '0.5rem'}} fullWidth>
            <InputLabel id="select-type">Profissional de Saúde</InputLabel>
            <Select
              labelId="select-doctor"
              id="select-t"
              value={Object.keys(this.state.doctor_list).length>0 ? this.state.doctor_id : ''}
              label="Profissional de Saúde"
              onChange={(e) => this.setState({doctor_id: e.target.value})}
            >
              {Object.keys(this.state.doctor_list).map(key => {
                  return <MenuItem key={key} value={key}>{this.state.doctor_list[key]}</MenuItem>
                })
              }
            </Select>
          </FormControl>
          <D h="1rem" />
          </>}
          {this.state.contact_within_hoursContext && <>
          <TextField
            fullWidth
            variant="outlined"
            label="Disparar follow up depois de"
            type="number"
            InputProps={{
              endAdornment: <InputAdornment position="end">horas</InputAdornment>
            }}
            value={this.state.contact_within_hours}
            onChange={(e) => this.setState({ contact_within_hours: e.target.value })}
          />
          <D h="1rem" />
          </>}
          {this.state.notesContext && <>
          <TextField
            fullWidth
            variant="outlined"
            label="Anotação de Tratamento"
            multiline
            value={this.state.notes}
            inputProps={{ maxLength: 512 }}
            onChange={(e) => this.setState({ notes: e.target.value })}
          />
          <D h="1rem" />
          </>}
          {this.state.prescriptionContext && <>
          <TextField
            fullWidth
            variant="outlined"
            label="Orientação e Medicação"
            multiline
            value={this.state.medication}
            inputProps={{ maxLength: 512 }}
            onChange={(e) => this.setState({ medication: e.target.value })}
          />
          <D h="1rem" />
          </>}
          <D h="1rem" />
        </DialogContent>
        <DialogActions>
          {this.state.read_only && <>
          <Button variant="outlined" color="primary" onClick={this.props.dialogClose}>Fechar</Button>
          </>}
          {!this.state.read_only && <>
          <Button variant="outlined" color="primary" onClick={this.props.dialogClose}>Cancelar</Button>
          <Button variant="outlined" color="primary" onClick={this.handleSave}>Salvar</Button>
          </>}
        </DialogActions>
      </D>
    );
  }
}


















